import React from 'react';
import { CardProps, StatCardProps } from '@/types/components';
import {
  Card as KitCard,
  CardHeader as KitCardHeader,
  CardTitle as KitCardTitle,
  CardContent as KitCardContent,
} from '@/design-system/card';
import { cn } from '@/design-system/lib/utils';

export const Card: React.FC<CardProps> = ({
  children,
  title,
  className = '',
}) => {
  return (
    <KitCard padding="none" className={cn('overflow-hidden', className)}>
      {title && (
        <KitCardHeader className="border-b border-stroke-soft-200 px-6 py-4">
          <KitCardTitle>{title}</KitCardTitle>
        </KitCardHeader>
      )}
      <KitCardContent className="p-6">{children}</KitCardContent>
    </KitCard>
  );
};

/** Icon chip fills per CardColor — kit state tokens (lighter bg + dark text). */
const CHIP_CLASSES: Record<NonNullable<StatCardProps['color']>, string> = {
  blue: 'bg-(--state-information-lighter) text-(--state-information-dark)',
  green: 'bg-(--state-success-lighter) text-(--state-success-dark)',
  yellow: 'bg-(--state-away-lighter) text-(--state-away-dark)',
  red: 'bg-(--state-error-lighter) text-(--state-error-dark)',
  purple: 'bg-(--state-feature-lighter) text-(--state-feature-dark)',
};

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon,
  color = 'blue',
  className = '',
}) => {
  return (
    <KitCard padding="lg" className={className}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-medium uppercase tracking-wider text-text-sub-600">
            {title}
          </p>
          <p className="mt-2 text-3xl font-medium tracking-tight tabular-nums text-text-strong-950">
            {value}
          </p>
        </div>
        {icon && (
          <div className={cn('rounded-lg p-3', CHIP_CLASSES[color])}>
            {icon}
          </div>
        )}
      </div>
    </KitCard>
  );
};
